module.exports = __webpack_public_path__ + "assets/block-circle.101aee1a.svg";